<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M9.9987 1.66797C7.6987 1.66797 5.83203 3.53464 5.83203 5.83464C5.83203 8.13464 7.6987 10.0013 9.9987 10.0013C12.2987 10.0013 14.1654 8.13464 14.1654 5.83464C14.1654 3.53464 12.2987 1.66797 9.9987 1.66797ZM11.807 5.4263L9.55703 7.6763C9.4737 7.75964 9.2987 7.84297 9.18203 7.86797L8.3237 7.98464C8.00703 8.0263 7.79036 7.80964 7.84036 7.5013L7.96536 6.64297C7.98203 6.5263 8.06536 6.3513 8.15703 6.26797L10.407 4.01797C10.7904 3.63464 11.2487 3.4513 11.8154 4.01797C12.3737 4.59297 12.1904 5.04297 11.807 5.4263Z"
      fill="currentColor"
    />
    <path
      d="M10.0008 11.668C5.82578 11.668 2.42578 14.468 2.42578 17.918C2.42578 18.1513 2.60911 18.3346 2.84245 18.3346H17.1591C17.3925 18.3346 17.5758 18.1513 17.5758 17.918C17.5758 14.468 14.1758 11.668 10.0008 11.668Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AdvancedPayerUpdateIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>